import React from 'react';
import PropTypes from 'prop-types';
import style from './ExpandButton.module.css';

function ExpandButton({
  stroke,
  size,
  color,
  direction,
  expanded,
  display,
  handleClick,
  margin,
}) {
  const padUnit = size / 5;
  const width = size + padUnit * 2;
  const center = width / 2;
  return (
    <div
      className={style.buttonContainer}
      onClick={handleClick}
      style={{ display, margin }}
    >
      {direction === 'right' ? (
        <svg className={style.svg} width={width} height={width}>
          <path
            d={`M${padUnit * 2} ${padUnit} L${width - padUnit * 2} ${width / 2} L${padUnit * 2} ${width - padUnit}`}
            transform={expanded ? `rotate(90, ${center}, ${center})` : 'scale(1)'}
            fill="none"
            strokeWidth={stroke}
            stroke={color}
          />
        </svg>
      ) : (
        <svg className={style.svg} width={width} height={width}>
          <path
            d={`M${padUnit} ${padUnit * 2} L${width / 2} ${width - padUnit * 2} L${width - padUnit} ${padUnit * 2}`}
            transform={expanded ? `rotate(180, ${center}, ${center})` : 'scale(1)'}
            fill="none"
            strokeWidth={stroke}
            stroke={color}
          />
        </svg>
      )}
    </div>
  );
}

ExpandButton.propTypes = {
  stroke: PropTypes.number.isRequired,
  size: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
  direction: PropTypes.string.isRequired,
  expanded: PropTypes.bool.isRequired,
  display: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  margin: PropTypes.string,
};

export default ExpandButton;
